import Paper from '@material-ui/core/Paper'
import styled from 'styled-components'

const CardProduct = styled(Paper)`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  width: 80%;
  border-radius: 8px;
  padding: 58px;
  margin-bottom: 22px;
  @media (max-width: 1100px) {
    width: 100%;
    height: 100%;
    padding: 5%;
  }
  @media (max-width: 700px) {
    padding: 4%;
  }
`
export default CardProduct
